import log from "loglevel"

log.setDefaultLevel("debug")

export const logger = log
